import React, { Component } from "react";

class Footer extends Component {
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Enables the smooth scroll animation
    });
  };

  render() {
    return (
      <div className="footer">
        <div className="container">
          <div className="row middle-xs">
            <div className="col-sm-6">
              <p className="lead">
                Have a project or just want to say hi? <br />
                Get in touch and let's make something awesome!
              </p>
            </div>
            <div className="col-sm-6 footer-links">
              <li>
                <a
                  href="https://www.linkedin.com/in/kimberly-bicknese/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="http://instagram.com/kimbickneseart"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Art Instagram
                </a>
              </li>
              {/* <li>
                <a
                  href="mailto:synthoxide@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Email
                </a>
              </li> */}
            </div>
          </div>
        </div>

        {/* Scroll to top button */}
        <div className="back-to-top" onClick={this.scrollToTop}></div>
      </div>
    );
  }
}

export default Footer;
